export default __webpack_public_path__ + "static/media/2.89fc5d41.PNG";